import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconShieldSearch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldSearch"><Path d="M3.5 5.5L12 2L20.5 5.5V13C20.5 17.6944 16.6944 21.5 12 21.5C7.30558 21.5 3.5 17.6944 3.5 13V5.5Z" stroke="currentColor" strokeLinecap="square"/><Circle cx="11" cy="11" r="3.5" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 13.5L16 16" stroke="currentColor"/></CentralIconBase>;
});

export default IconShieldSearch;
